import DoneIcon from "@mui/icons-material/Done";
import { DoneAll } from "@mui/icons-material";
import resetImage from "../../../images/retry.png";
import Tooltip from "@mui/material/Tooltip";

export default function Retry(props) {
  const { message } = props;
  return (
    <div>
      <>
        {message?.type === "SENT" &&
        message?.message?.showSingleTick !== undefined &&
        (typeof message?.message?.showSingleTick === "boolean" ||
          typeof message?.message?.showDoubleTick === "boolean") ? (
          message?.message?.showDoubleTick ? (
            <div>
              <Tooltip
                title={<span style={{ fontSize: "10px" }}>DELIVERED</span>}
              >
                <DoneAll
                  style={{
                    color: "green",
                  }}
                />
              </Tooltip>
            </div>
          ) : message?.message?.showSingleTick ? (
            <div>
              <Tooltip title={<span style={{ fontSize: "10px" }}>SENT</span>}>
                <DoneIcon
                  style={{
                    color: "green",
                  }}
                />
              </Tooltip>
            </div>
          ) : (
            <>
              <Tooltip
                title={
                  <span style={{ fontSize: "10px" }}>
                    Please click the icon to Retry
                  </span>
                }
              >
                <img
                  src={resetImage}
                  alt="reset"
                  onClick={() => props.handleCustomerRetryMsg(message)}
                  style={{ cursor: "pointer", width: "15px" }}
                />
              </Tooltip>
            </>
          )
        ) : null}

        {message?.creator === "CUSTOMER" &&
        props?.config?.chatRetry &&
        message?.message?.status === "SENT" ? (
          <Tooltip title={<span style={{ fontSize: "10px" }}>SENT</span>}>
            <DoneIcon
              style={{
                color: "green",
              }}
            />
          </Tooltip>
        ) : message?.creator === "CUSTOMER" &&
          props?.config?.chatRetry &&
          message?.message?.status === "DELIVERED" ? (
          <Tooltip title={<span style={{ fontSize: "10px" }}>DELIVERED</span>}>
            <DoneAll
              style={{
                color: "green",
              }}
            />
          </Tooltip>
        ) : null}
      </>
    </div>
  );
}
